export default __webpack_public_path__ + "static/media/sinfin-logo.8133a9b6.svg";